import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { SDKAdminServiceRB } from 'rainbow-web-sdk/services/admin/admin.service';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';

export class AdminPlugin extends Plugin {
    public static initialize(): AdminPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[AdminPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[AdminPlugin] initialized");
            window.rainbow.plugins[AdminPlugin.name] = new AdminPlugin();
            SDKAdminServiceRB.getInstance();
        }

        return window.rainbow.plugins[AdminPlugin.name];
    }

    private constructor() {
        super();
    }
}
